import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { isTrialLicense } from '@monorepo/shared/src/graph/selectors/license-selector';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import { SCREEN_RESIZE_MEDIA_QUERY } from 'types';
import AssignmentsAndReporting from './AssignmentsAndReporting';
import GridColumnLayout from 'components/layout/GridColumnLayout';
import GreetingHeader from './GreetingHeader';
import HomeQuadrantLinkRow from './HomeQuadrantLinkRow';
import TeachingOrderGridRow from './TeachingOrderGridRow';
import StoryBooks from './StoryBooks';

const HomeGrid = () => {
  const [{ me = { firstName: '', lastName: '' } }] = useUserStore();
  const license = me?.licenses?.[0];

  const isIpad = useMediaQuery(SCREEN_RESIZE_MEDIA_QUERY.IPAD);
  const classes = useStyles({ resize: isIpad });

  return (
    <GridColumnLayout
      containerProps={{ style: { maxWidth: 1600, flexWrap: 'wrap' } }}
      gridContainerProps={{ className: classes.grid, wrap: 'wrap' }}
      classes={{ root: classes.root }}
    >
      <GreetingHeader
        name={`${me?.firstName} ${me?.lastName}`}
        trialLicense={isTrialLicense(license) ? license : null}
      />
      <TeachingOrderGridRow />
      <Box className={classes.row}>
        <AssignmentsAndReporting
          paperClass={classes.paperClass}
          xs={5}
          classes={{ root: classes.root }}
          isTrialLicense={isTrialLicense(license)}
        />
        <StoryBooks
          paperProps={{ className: classes.paperClass }}
          gridProps={{ classes: { root: classes.root } }}
          xs={7}
        />
      </Box>
      <Box className={classes.row}>
        <HomeQuadrantLinkRow paperClass={classes.paperClass} classes={{ root: classes.root }} />
      </Box>
    </GridColumnLayout>
  );
};

const useStyles = makeStyles((theme) => ({
  root: ({ resize }: any) => ({
    width: '100%',
    maxWidth: resize ? '100%' : 'unset',
  }),
  grid: {
    flexGrow: 1,
  },
  paperClass: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    minHeight: 164,
    margin: theme.spacing(4),
    textDecoration: 'none',
  },
  row: ({ resize }: any) => ({
    display: 'flex',
    flexDirection: resize ? 'column' : 'row',
  }),
}));

export default HomeGrid;
